import { sendClientRequest } from '@/utils/client-request'

export const toggleWishlistApi = (vendorId: string, productId: string, variantId: string, session: any) =>
  sendClientRequest({
    url: '/wishlist',
    method: 'POST',
    session,
    headers: { Vendor: vendorId } as any,
    body: { products: [{ id: productId, variantId }] },
  })

export const fetchWishlistApi = (vendorId: string, session: any) =>
  sendClientRequest({ url: '/wishlist', session, headers: { Vendor: vendorId } as any })
